import { Route } from '@/app/router'


const ShipmentClaim = () => import('./index.vue')

export default new Route('/shipments-claims/:id', ShipmentClaim)
	.as('Dashboard:ShipmentClaim')
